module.exports = __webpack_public_path__ + "static/media/wideLogo-icon-new.338fb2e3.svg";